// Packs du moteur v2 (données). Futures lignes de la table engine_packs (lot V3).
import algebra_develop from '../packs/algebra.develop.json';
import algebra_equations from '../packs/algebra.equations.json';
import algebra_factor from '../packs/algebra.factor.json';
import algebra_traps from '../packs/algebra.traps.json';
import analyse_complexes from '../packs/analyse.complexes.json';
import analyse_derivees from '../packs/analyse.derivees.json';
import analyse_exp from '../packs/analyse.exp.json';
import analyse_explog from '../packs/analyse.explog.json';
import analyse_limites from '../packs/analyse.limites.json';
import analyse_suites from '../packs/analyse.suites.json';
import analyse_trig from '../packs/analyse.trig.json';
import arith_fractions from '../packs/arith.fractions.json';
import arith_entiers from '../packs/arith.entiers.json';
import arith_puissances from '../packs/arith.puissances.json';
import chimie_equations from '../packs/chimie.equations.json';
import core from '../packs/core.json';
import formula from '../packs/formula.json';
import geometrie_deductive from '../packs/geometrie.deductive.json';
import geometrie_vecteurs from '../packs/geometrie.vecteurs.json';
import grandeurs from '../packs/grandeurs.json';
import physique_unites from '../packs/physique.unites.json';
import proba_binomiale from '../packs/proba.binomiale.json';
import skillcards from '../packs/skillcards.json';
import tables from '../packs/tables.json';

export const PACKS = [
  algebra_develop,
  algebra_equations,
  algebra_factor,
  algebra_traps,
  analyse_complexes,
  analyse_derivees,
  analyse_exp,
  analyse_explog,
  analyse_limites,
  analyse_suites,
  analyse_trig,
  arith_fractions,
  arith_entiers,
  arith_puissances,
  chimie_equations,
  core,
  formula,
  geometrie_deductive,
  geometrie_vecteurs,
  grandeurs,
  physique_unites,
  proba_binomiale,
  skillcards,
  tables,
];
export default PACKS;
